import React from 'react'
import { useIntl } from 'react-intl'
import { CANCEL } from 'app/constants/button'
import { useGroupDialog } from '../contexts/GroupDialogContext'
import SubmitDialog from 'app/componentV4/Dialog/SubmitDialog'
import { DIALOG_KEYS } from '../constants'

const DeleteGroup = () => {
  const { formatMessage } = useIntl()
  const { dialogState, closeDialog } = useGroupDialog()
  const { open, action, isLoading } = dialogState[DIALOG_KEYS.GROUP_DELETE]

  const handleSubmit = () => {
    action?.onSubmit?.()
  }

  return (
    <SubmitDialog
      id="dialog-delete-subscriber"
      open={open}
      type={CANCEL}
      title={`${formatMessage({ id: 'group.details.info.deleteGroup.btn' })}?`}
      description={formatMessage({
        id:
          action?.type === 'menu'
            ? 'groupv4.menu.deleteGroup.description'
            : 'groupv4.selected.deleteGroup.description',
      })}
      isLoading={isLoading}
      submitText={formatMessage({
        id: 'action.delete',
      })}
      onSubmit={handleSubmit}
      closeText={formatMessage({
        id: 'text.close',
      })}
      onClose={() => closeDialog(DIALOG_KEYS.GROUP_DELETE)}
    />
  )
}

export default DeleteGroup
